import React, { useEffect, useState } from 'react'
import './gacha.css'

/** 이미지 경로. public/images/gacha/ (public/event/ 는 라우트와 겹쳐 못 쓴다) 에 @2x·@3x 가 있다. */
export const asset = (name: string) => `${process.env.PUBLIC_URL}/images/gacha/${name}@2x.png`
export const srcSet = (name: string) =>
  `${process.env.PUBLIC_URL}/images/gacha/${name}@2x.png 2x, ${process.env.PUBLIC_URL}/images/gacha/${name}@3x.png 3x`

/** 이 페이지에 있는 동안만 검색 제외 표시를 단다(QrEvent 와 같은 방식). */
const useNoIndex = () => {
  useEffect(() => {
    const meta = document.createElement('meta')
    meta.name = 'robots'
    meta.content = 'noindex, nofollow'
    document.head.appendChild(meta)
    return () => {
      meta.remove()
    }
  }, [])
}

const W = 390
const H = 844
const fit = () => Math.min(window.innerWidth / W, window.innerHeight / H)

/**
 * 디자인 원본이 390×844 고정 좌표라 그 판을 통째로 화면에 맞춰 늘이고 줄인다.
 * 연출 좌표(캡슐이 날아가는 자리 등)를 기기마다 다시 계산하지 않아도 된다.
 */
const GachaFrame: React.FC<{
  appClassName?: string
  frameClassName?: string
  /** 판 밖, 화면 전체에 까는 배경(축소/확대 안 함) */
  backdrop?: React.ReactNode
  /** 판 위, 화면 전체를 덮는 층(확인창 등) */
  overlay?: React.ReactNode
  children: React.ReactNode
}> = ({ appClassName = '', frameClassName = '', backdrop, overlay, children }) => {
  useNoIndex()
  const [scale, setScale] = useState(fit)
  useEffect(() => {
    const onResize = () => setScale(fit())
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])
  return (
    <div className={`g-frame ${frameClassName}`}>
      {backdrop}
      <div
        className={`g-app ${appClassName}`}
        style={{ transform: `translate(-50%, -50%) scale(${scale})` }}
      >
        {children}
      </div>
      {overlay}
    </div>
  )
}

export default GachaFrame
